module.exports = __webpack_public_path__ + "img/vbf.77ed1e6d.webp";